import moment from 'moment'
import 'moment-timezone'
import store from "@/store";
export const custom_table_filters = {
    filters: {
        json_datetime_to_readable_str: function (json_datetime) {
            let time_str = moment(json_datetime['$date']).tz(store.state.current_system_timezone).format('HH:mm:ss')
            let date_str = moment(json_datetime['$date']).tz(store.state.current_system_timezone).startOf('day').format('DD/MM/YYYY')
            return `${time_str} ${date_str}`
        },
        role_id_to_role_name: function (role_id, all_roles) {
            console.log(all_roles)
            return all_roles.find(role => role._id['$oid'] === role_id['$oid']).name
        }
    }
}

/*
import moment from 'moment'
import 'moment-timezone'
import store from "@/store";
export const custom_table_filters = {
    filters: {
        // eslint-disable-next-line no-unused-vars
        json_datetime_to_readable_str: function (json_datetime, e, time_format = 'HH:mm', date_format='DD/MM/YYYY') {
            let time_str = moment(json_datetime['$date']).tz(store.state.current_system_timezone).format(time_format.toString())
            let date_str = moment(json_datetime['$date']).tz(store.state.current_system_timezone).startOf('day').format('DD/MM/YYYY'.toString())
            return `${time_str} ${date_str}`
        },
        role_id_to_role_name: function (role_id, all_roles) {
            console.log(all_roles)
            return all_roles.find(role => role._id['$oid'] === role_id['$oid']).name
        }
    }
}
 */